import { ProviderInterface } from './../../../../model/user/provider-interface';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { Component, OnDestroy, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription, of, Subject, takeUntil } from 'rxjs';
import { DialogService } from '../../../../services/dialog-service/dialog-service.service';
import { FeatbitService } from 'src/app/services/featbit/featbit.service';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent implements OnInit, OnDestroy {
    currentUser$ = this.userService.currentUserObservable;
    providers$: Observable<ProviderInterface[]> = of([]);
    activeProvider$: Observable<ProviderInterface> = of({} as ProviderInterface);
    activeProvider: ProviderInterface;
    login_activated = false;
    providers: ProviderInterface[] = [];

    private destroy$ = new Subject<void>();
    isComposerFlag = this.featbitService.isEnabled('composer');

    private readonly subscriptions = new Subscription();

    @Input()
    loggedIn: boolean;

    constructor(
        public router: Router,
        private userService: UserService,
        private cd: ChangeDetectorRef,
        private headerService: HeaderServiceService,
        private dialogService: DialogService,
        private featbitService: FeatbitService
    ) { }

    ngOnInit(): void {
        this.providers$ = this.headerService.providersObservable$;
        this.subscriptions.add(this.providers$
            .pipe(takeUntil(this.destroy$))
            .subscribe((providers) => {
                this.providers = providers.sort((a, b) => a.name.localeCompare(b.name));
        }));
        this.activeProvider$ = this.headerService.activeProviderObservable$;
        this.subscriptions.add(this.headerService.activeProviderObservable$
            .pipe(takeUntil(this.destroy$))
            .subscribe(
            (activeProvider) => {
                this.activeProvider = activeProvider;
            }
        ));
        document.onreadystatechange = () => {
            if (document.readyState === 'complete') {
                setTimeout(() => {
                    this.login_activated = true;
                    this.cd.detectChanges();
                }, 2000);
            }
        };
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.subscriptions.unsubscribe();
    }

    //---------Buttons----------------------------------------------------------
    login(): void {
        this.dialogService.openLoginDialog().subscribe((result) => {
            if (result === 'success') {
                // this.router.navigate(['/']);
            }
        });
    }

    logout(): void {
        this.userService.logout();
    }

    register(): void {
        this.router.navigate(['registry']);
    }

    listing(): void {
        this.dialogService.openListingRequestDialog();
    }

    openMySettings() {
        this.router.navigate(['profil/settings']);
    }

    openMyProducts() {
        this.router.navigate(['meineProdukte']);
    }

    openComposer() {
        this.router.navigate(['composer']);
    }

    openGaiaX() {
        this.router.navigate(["select-file"]);
    }

}
